import { Directive, HostListener, input, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[coreCustomTooltip]',
  providers: [NgbTooltip],
  standalone: true,
})
export class CustomTooltipDirective {
  private tooltip = inject(NgbTooltip);

  tooltipText = input<string>('', { alias: 'coreCustomTooltip' });

  constructor() {
    this.tooltip.placement = 'top';
    this.tooltip.container = 'body';
  }

  @HostListener('mouseenter')
  @HostListener('focusin')
  onShow() {
    this.tooltip.ngbTooltip = this.tooltipText();
    this.tooltip.open();
  }

  @HostListener('mouseleave')
  @HostListener('focusout')
  onHide() {
    this.tooltip.close();
  }

  @HostListener('click')
  onClick() {
    this.tooltip.close();
  }
}
